// extracted by mini-css-extract-plugin
module.exports = {"app":"MainLayout_app__XK2Rb","button":"MainLayout_button__3-VBe"};